<template>
  <div class="p-8">
    <div class="space-y-6">
      <div class="flex -mx-4">
        <div class="w-1/2">
          <div class="px-4">
            <div class="border p-4 rounded-lg space-y-2">
              <h2 class="font-semibold uppercase text-gray-600">
                Site Statstics
              </h2>
              <div class="flex flex-wrap -mx-4 -mt-4">
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                    >
                      <div>
                        <i class="material-icons text-6xl text-indigo-600">
                          person
                        </i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Total Drivers</p>
                        <p class="text-4xl">{{ stats.totalDrivers }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                    >
                      <div>
                        <i class="material-icons text-6xl text-blue-600">
                          directions_walk
                        </i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Total Passengers</p>
                        <p class="text-4xl">{{ stats.totalUsers }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                    >
                      <div>
                        <i class="material-icons text-6xl text-green-600">
                          person
                        </i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Online Drivers</p>
                        <p class="text-4xl">{{ stats.totalActiveFleets }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                    >
                      <div>
                        <i class="material-icons text-6xl text-teal-600">
                          local_taxi
                        </i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Total Active Fleet</p>
                        <p class="text-4xl">{{ stats.totalActiveFleets }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-1/2">
          <div class="px-4">
            <div class="border p-4 rounded-lg space-y-2">
              <h2 class="font-semibold uppercase text-gray-600">
                Ride Statstics
              </h2>
              <div class="flex flex-wrap -mx-4 -mt-4">
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                    >
                      <div>
                        <i class="material-icons text-6xl text-blue-600">
                          local_taxi
                        </i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Total Rides</p>
                        <p class="text-4xl">{{ stats.totalTrips }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                    >
                      <div>
                        <i class="material-icons text-6xl text-red-600">
                          cancel
                        </i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Cancelled Rides</p>
                        <p class="text-4xl">{{ stats.totalCanceledTrips }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                    >
                      <div>
                        <i class="material-icons text-6xl text-yellow-600">
                          loop
                        </i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Running Rides</p>
                        <p class="text-4xl">{{ stats.totalRunningTrips }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="p-4">
                    <div
                      class="w-full px-8 py-4 space-x-4 flex items-center bg-white rounded shadow"
                    >
                      <div>
                        <i class="material-icons text-6xl text-green-600">
                          check_circle_outline
                        </i>
                      </div>
                      <div class="font-semibold">
                        <p class="text-gray-600">Completed Rides</p>
                        <p class="text-4xl">{{ stats.totalCompletedTrips }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="space-y-4">
        <h2 class="font-semibold uppercase text-gray-600">
          Recent Rides
        </h2>

        <div
          class="inline-block min-w-full shadow rounded-lg overflow-hidden mt-4"
        >
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Dispatcher
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Rider Name
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Driver Name
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Pick / Drop Address
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Type
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Date
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Ride Fare
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Status
                </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              ></th>
              </tr>
            </thead>
            <tbody v-if="latestRides.length">
              <tr v-for="ride in latestRides" :key="ride._id">
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="whitespace-no-wrap">{{ ride.dispatcher ? ride.dispatcher.firstName + " " + ride.dispatcher.lastName : " - " }}</p>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">
                    {{
                      ride.passenger ? ride.passenger.firstName +
                      " " +
                      (ride.passenger.lastName || "")
                     : "Unknown"}}
                  </p>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  {{ ride.driver ? ride.driver.firstName + " " + ride.driver.lastName : "Unknown"}}
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <div class="flex items-center space-x-2">
                    <i class="material-icons text-green-600">location_on</i>
                    <span>
                      {{ ride.pickUpAddress.name }}
                    </span>
                  </div>
                  <div class="flex items-center space-x-2">
                    <i class="material-icons text-red-600">location_on</i>
                    <span>
                      {{ ride.dropOffAddress.name }}
                    </span>
                  </div>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">
                    {{ ride.type }}
                  </p>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">
                    {{ formatDate(ride.pickupTimestamp) }}
                  </p>
                  <p class="mt-1 text-gray-900 whitespace-no-wrap">
                    {{ formatDate(ride.endTimestamp) }}
                  </p>
                </td>
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">
                    {{ ride.fare ? ride.fare.toFixed(2) : "0" }}
                  </p>
                </td>
                <td
                  class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right"
                >
                  <span
                    class="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight"
                  >
                    <span
                      aria-hidden=""
                      class="absolute inset-0 bg-green-200 opacity-50 rounded-full"
                    ></span>
                    <span class="relative">{{ ride.status }}</span>
                  </span>
                </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  <a :href="'/rides/' + ride._id + '/show'" target="self"
                    ><i class="material-icons mr-2">visibility</i></a
                  >
                </p>
              </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td
                  colspan="10"
                  class="bg-white py-4 text-center text-gray-600 font-semibold"
                >
                  <div v-if="loading" class="inline-block">
                    <i class="material-icons text-6xl spin">sync</i>
                    <span class="block invisible">Loading...</span>
                  </div>
                  <div v-else class="inline-block">
                    <i class="material-icons text-6xl">warning</i>
                    <span class="block">No latest rides!</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Dashboard",
  data() {
    return {
      stats: {
        totalTrips: 0,
        totalUsers: 0,
        totalDrivers: 0,
        totalCompletedTrips: 0,
        totalRunningTrips: 0,
        totalCanceledTrips: 0,
        totalActiveFleets: 0,
        revenue: 0,
      },
      latestRides: [],
      loading: false,
    };
  },
  created() {
    this.getStats();
    this.getLatestRides();
  },
  methods: {
    getStats() {
      this.$http
        .get("dashboard")
        .then(response => (this.stats = response.data))
        .catch(err => console.log(err));
    },
    getLatestRides() {
      this.loading = true;
      this.$http
        .get('trips?populate=["driver","passenger","dispatcher"]')
        .then(response => (this.latestRides = response.data.data))
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    formatDate(date) {
      return moment(date).format("MMM D, YYYY HH:mm");
    },
  },
};
</script>
